module.exports = __webpack_public_path__ + "static/media/QuickHelp.5f1a542b.svg";